import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LogoutIcon from "@mui/icons-material/Logout";
import TranslateIcon from "@mui/icons-material/Translate";
import { Avatar, IconButton } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import {
  getUserFromLocalStorage,
  removeUserFromLocalStorage,
} from "hooks/LocalStorage";
import { useTranslation } from "i18n";
import { getFlag } from "utils/Currency&Language";

import Package from "../../../package.json";

import PoweredByDivyAI from "components/poweredByDivyAI";
import { CurrencyContext } from "pages/useContext";

import "./header-drawer.css";

export default function HeaderDrawer({
  open,
  onCloseDrawer,
  handleOpenModalLangs,
}) {
  const navigate = useNavigate();
  const { currency } = useContext(CurrencyContext);
  const { language, t } = useTranslation();
  const user = getUserFromLocalStorage();
  const initials = `${user?.firstName?.charAt() || ""}${
    user?.lastName?.charAt() || ""
  }`;

  const handleNavigate = (href) => {
    onCloseDrawer();
    navigate(href);
  };

  const logOut = () => {
    removeUserFromLocalStorage();
    handleNavigate("/");
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onCloseDrawer}
      className="account-drawer"
      PaperProps={{ className: "account-drawer__paper" }}
    >
      <div className="account-drawer__inner">
        <div className="account-drawer__top">
          <p>{t("navigation.myAccount")}</p>
          <IconButton
            onClick={onCloseDrawer}
            size="small"
            aria-label={t("common.close")}
          >
            <CloseIcon sx={{ width: 18 }} />
          </IconButton>
        </div>

        <div className="account-drawer__profile">
          <Avatar className="account-drawer__avatar">{initials}</Avatar>
          <div>
            <h3>
              {user?.firstName} {user?.lastName}
            </h3>
            {user?.type && user?.type !== "MEMBER" && (
              <span className="account-drawer__role">{user.type}</span>
            )}
            {user?.memberId && <p>{user.memberId}</p>}
            {user?.email && <p>{user.email}</p>}
          </div>
        </div>

        <nav className="account-drawer__nav" aria-label={t("navigation.myAccount")}>
          <button
            type="button"
            className="account-drawer__item"
            onClick={() => handleNavigate("/my-account/profile")}
          >
            <AccountCircleIcon />
            <span>{t("navigation.myAccount")}</span>
          </button>
          <button
            type="button"
            className="account-drawer__item"
            onClick={() => {
              onCloseDrawer();
              handleOpenModalLangs();
            }}
          >
            <TranslateIcon />
            <span>{t("languageModal.title")}</span>
            <em>
              {getFlag(currency?.currency)}
              {language?.language}
              <i />
              {currency?.currency}
            </em>
          </button>
          <button
            type="button"
            className="account-drawer__item is-danger"
            onClick={logOut}
          >
            <LogoutIcon />
            <span>{t("navigation.logOut")}</span>
          </button>
        </nav>

        <div className="account-drawer__footer">
          <PoweredByDivyAI variant="drawer" />
          <div className="account-drawer__social">
            <IconButton
              size="small"
              component="a"
              href="https://www.facebook.com/SatyamHolidays/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon sx={{ width: 20 }} />
            </IconButton>
            <IconButton
              size="small"
              component="a"
              href="https://www.instagram.com/satyamholidays_/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon sx={{ width: 20 }} />
            </IconButton>
            <IconButton
              size="small"
              component="a"
              href="https://www.linkedin.com/company/satyam-holidays-b-v/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon sx={{ width: 20 }} />
            </IconButton>
          </div>
          <p>{t("footer.version", { version: Package?.version })}</p>
        </div>
      </div>
    </Drawer>
  );
}
